import {DeviceSessions} from '../models/DeviceSessions';
import {Dto} from 'common';
import {RecentAccountActivitySubscriptionDto} from './recentAccountActivitySubscription.dto';

export class RecentAccountActivityDto extends Dto {
    code: string;
    email: string;
    fullName: string;
    telephone: string;
    country: string;
    specialty: string;
    zipCode: string;
    accountRole: string;
    createdOn: number;
    sessionsOneWeek: number;
    sessionsOneMonth: number;
    sessionsThreeMonths: number;
    sessionsSixMonths: number;
    sessionsTwelveMonths: number;
    totalSessions: number;
    totalNumberOfPayments: number;
    totalPaymentsAmount: number;
    lastUsed: number;
    deviceSessions: DeviceSessions[];
    serialCodes: string[];
    latestNonExpiredSubscription: RecentAccountActivitySubscriptionDto;
    subscriptions: RecentAccountActivitySubscriptionDto[];

    public deserialize(input: any): this {
        Object.assign(this, input);

        this.deviceSessions = this.deserializeArray(input.deviceSessions, DeviceSessions);
        this.subscriptions = this.deserializeArray(input.subscriptions, RecentAccountActivitySubscriptionDto);

        return this;
    }
}
